import React, { useEffect } from 'react';
import Doctor from '../Doctor/Doctor';
import { useState } from 'react';

const Doctors = () => {
    const [doctors, setDoctors] = useState([])
    useEffect( () =>{
        fetch('https://fathomless-badlands-18502.herokuapp.com/doctors')
        .then(res => res.json())
        .then(data => setDoctors(data))
    }, [])
    return (
        <section className="doctors">
            <div className="container">
                <h5 className="text-center  text-primary mb-5">Our Doctors</h5>
                <div className="row">
                    {
                        doctors.map(doctor => <Doctor key={doctor._id} doctor={doctor}></Doctor>)
                    }
                </div>
            </div>
        </section>
    );
};

export default Doctors;